export enum HtmlPageType {
    FOOTER = 'FOOTER',
    LINK = 'LINK'
}
